export const isDeveloperMode =
  localStorage.getItem('developerMode') ===
  'vubmsWU4CekWZ2K5x444W45SYBWJ6yrsuttEm62xYgjE9mNCQBUA9rHyymFFVLfE';
